export const HOME = {
  emergentLink: "emergent-link",
  heroReserveBtn: "hero-reserve-btn",
  heroMenuBtn: "hero-menu-btn",
  heroTitle: "hero-title",
  heroSubtitle: "hero-subtitle",
  aboutSection: "about-section",
  menuSection: "menu-section",
  gallerySection: "gallery-section",
  locationSection: "location-section",
  callBtn: "call-btn",
  directionsBtn: "directions-btn",
  floatingReserveBtn: "floating-reserve-btn"
};

export const HEADER = {
  logo: "header-logo",
  navHome: "nav-home",
  navMenu: "nav-menu",
  navLocation: "nav-location",
  reserveBtn: "header-reserve-btn",
  langToggle: "lang-toggle",
  mobileMenuBtn: "mobile-menu-btn"
};

export const MENU_PAGE = {
  page: "menu-page",
  categoryTab: "category-tab",
  dishCard: "dish-card",
  dishName: "dish-name",
  dishPrice: "dish-price",
  dishDescription: "dish-description"
};

export const ADMIN = {
  loginForm: "admin-login-form",
  emailInput: "admin-email-input",
  passwordInput: "admin-password-input",
  loginBtn: "admin-login-btn",
  logoutBtn: "admin-logout-btn",
  dashboard: "admin-dashboard",
  tabContent: "admin-tab-content",
  tabMenu: "admin-tab-menu",
  tabGallery: "admin-tab-gallery",
  tabSettings: "admin-tab-settings",
  saveBtn: "admin-save-btn",
  addDishBtn: "admin-add-dish-btn",
  addCategoryBtn: "admin-add-category-btn",
  uploadBtn: "admin-upload-btn",
  deleteBtn: "admin-delete-btn",
  editBtn: "admin-edit-btn"
};
